import Hero from './components/Hero';
import Featured from './components/Featured';
import CaseStudies from './components/CaseStudies';
import Resume from './components/Resume';
import Skills from './components/Skills';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Featured />
      <CaseStudies />
      <Resume />
      <Skills />
      <Footer />
    </div>
  );
}
